module.exports = __webpack_public_path__ + "img/engagement_6.66f96227.jpg";